import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';
import BackstagePodcastProgramSortDropdown from '../BackstagePodcastProgramSortDropdown/BackstagePodcastProgramSortDropdown';

import './BackstagePodcastSortableSectionHeader.scss';

class BackstagePodcastSortableSectionHeader extends React.Component {
  static propTypes = {
    leftColumn: PropTypes.node.isRequired,
    onSortChange: PropTypes.func.isRequired,
    initialSortingOrder: PropTypes.string,
    isMobileDevice: PropTypes.bool,
  };

  render() {
    const { leftColumn, initialSortingOrder, isMobileDevice, onSortChange } = this.props;

    const sortableHeaderClasses = D.createBEM('BackstagePodcastSortableSectionHeader', {
      isMobile: this.props.isMobileDevice,
    });

    const headerClasses = D.createBEM('BackstagePodcastSortableSectionHeader__header', {
      isMobile: this.props.isMobileDevice,
    });

    return (
      <div className={sortableHeaderClasses}>
        <h3 className={headerClasses}>{leftColumn}</h3>
        {initialSortingOrder && !isMobileDevice && (
          <BackstagePodcastProgramSortDropdown
            onChange={onSortChange}
            initialSortingOrder={initialSortingOrder}
          />
        )}
      </div>
    );
  }
}

export default BackstagePodcastSortableSectionHeader;
